import { throttle } from 'throttle-debounce'

export default () => ({
    actualValue: null,
    showScrollbar: true,

    init() {
        const boundOnResize = this.onResize.bind(this)

        boundOnResize()
        window.addEventListener('resize', throttle(200, boundOnResize))
    },

    set value(value) {
        this.actualValue = value === '' ? null : value
    },

    get value() {
        return this.actualValue
    },

    onResize() {
        this.showScrollbar =
            this.$refs.scrollbar.offsetWidth <
            this.$refs.scrollbar.parentElement.offsetWidth
    },
})
